import { Component, OnInit } from '@angular/core';
import { loadMessages, locale } from 'devextreme/localization';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'ms-root',
  templateUrl: './khuyana.component.html'
})
export class KhuyanaComponent implements OnInit {

  constructor(
    protected config: PrimeNGConfig
  ) { }

  ngOnInit() {
    this.setTranslationsForPrimeng();
    this.setTranslationsForDevextreme();
  }

  private setTranslationsForPrimeng = () => {
    this.config.setTranslation({
      dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
      dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      today: 'Hoy'
    });
  }

  private setTranslationsForDevextreme = () => {
    loadMessages({
      'es': {
        'dxScheduler-switcherMonth': 'Mes',
        'dxScheduler-switcherWeek': 'Semana',
        'dxScheduler-switcherAgenda': 'Agenda'
      }
    });
    locale('es');
  }
}
